/**
 * @ngdoc    directive
 * @name     csm.ui.validators.directive:csmValidator
 * @restrict A
 * @param    {string=} csmRequired      "false"=value is not required.
 * @param    {string=} csmValidator     Error popup title.
 * @param    {string=} disableValidator "true"=skip validation.
 * @param    {expr=}   valCustom
 * Expression to return error string to indicate validation of the element.
 * Null=Valid, Non-null=invalid/error message to display. The parsed value will
 * be available in the expression as $value.
 *
 * @description
 * Validator to verify an input value has been supplied.
 **/
/* @ngInject */ export function csmValidator(CSMValidatorService) {
  return CSMValidatorService.makeDirective({
    doValidate: function (value) {
      /*----------------------------------------------------------*/
      /* Evaluate expression providing the parsed value as $value */
      /*----------------------------------------------------------*/
      var custom = this.element
        .scope()
        .$eval(this.attributes.valCustom, { $value: value });

      /*-------------------------------------------*/
      /* Undefined indicates no custom expression, */
      /* while a null indicates a valid expression */
      /*-------------------------------------------*/
      if (custom != undefined || custom === null) return custom;
      else
        return CSMValidatorService.BaseValidator.prototype.doValidate.call(
          this,
          value
        );
    }
  });
}
